export default "__VITE_ASSET__CyBLRnRb__"